module.exports = __webpack_public_path__ + "img/bottom_opening_zipper.1a953f9e.png";